import { NewLoginPage, ResetPasswordPage } from '@modules/Auth';
import AcceptInvitationPage from '@modules/configuration/Users/pages/AcceptInvitationPage';
import { RouteConfig } from './AppRoutes';

export const guestRoutes: RouteConfig[] = [
    {
        path: '/login',
        element: <NewLoginPage />,
    },
    {
        path: '/reset-password',
        element: <ResetPasswordPage />,
    },
    {
        path: '/invitation/accept',
        element: <AcceptInvitationPage />,
    },
];

